import React from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "src/context/Auth/context";
import { usePermissionPath } from "src/context/PermissionPath/context";
import { ICheckPermission } from "./interface";

const CheckPermission: React.FC<ICheckPermission> = ({
	minimumPermissionRequired,
	path,
	children
}) => {
	const {checkIfHasSpecificPermission} = useAuth();
	const { permissionPath } = usePermissionPath();
	const history = useHistory();

	if(!checkIfHasSpecificPermission(path ?? permissionPath ?? history.location.pathname, minimumPermissionRequired))
		return null;

	return <>{children}</>;
};

export default CheckPermission;
